<template>
  <div class="input-phone">
    <h1>{{ tipText }}</h1>
    <PhoneInput :phone="value" @doInput="doInput" />
    <div class="agreement" v-if="showAccountLogin">
      <VanCheckbox v-model="checked" @change="$emit('checkChange', checked)">
        <template #icon="props">
          <img
            v-if="props.checked"
            class="img-icon"
            src="@/assets/img/checkbox_select.png"
          />
          <img
            v-else
            class="img-icon"
            src="@/assets/img/checkbox_default.png"
          />
        </template>
        同意
      </VanCheckbox>
      <a :href="agreementUserUrl">《用户协议》</a>和
      <a :href="agreementPrivacyUrl">《隐私协议》</a>
    </div>

    <VanButton class="btn" round block color="#FF4444" @click="$emit('sendMsg')"
      >发送验证码</VanButton
    >
    <div v-if="showAccountLogin" class="tip" @click="handleUserLogin()">
      使用手机号+密码登录
    </div>
  </div>
</template>

<script>
import { Button as VanButton, Checkbox as VanCheckbox } from "vant";
import Config from "@/config/index.js";
import PhoneInput from "@/components/login/PhoneInput.vue";

export default {
  name: "InputPhonePage",
  props: {
    value: {
      type: String,
      default: ""
    },
    tipText: {
      type: String,
      default: "请输入手机号"
    },
    placeholder: {
      type: String,
      default: "请输入手机号"
    },
    showAccountLogin: {
      type: Boolean,
      default: true
    },
    select: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: this.select
    };
  },
  created() {
    let localPhone = sessionStorage.getItem("localPhone") || "";
    if (localPhone.length === 11) {
      this.$emit("input", localPhone);
    }
  },
  methods: {
    doInput(val) {
      this.$emit("input", val);
      if (val.length === 11) {
        sessionStorage.setItem("localPhone", val); //其他地方做回写
      }
    },
    handleUserLogin() {
      window.location.href = "./accountLogin.html";
    }
  },
  components: { VanButton, PhoneInput, VanCheckbox },
  computed: {
    agreementUserUrl() {
      return Config.agreementUserUrl;
    },
    agreementPrivacyUrl() {
      return Config.agreementPrivacyUrl;
    }
  }
};
</script>
<style lang="scss" scoped>
.input-phone {
  width: 100%;
  height: 100vh;
  padding: 32px;
  h1 {
    color: #222;
    font-size: 24px;
    margin-top: 56px;
    font-weight: 500;
    margin-bottom: 60px;
  }
  .tip {
    text-align: center;
    color: #969fa9;
    margin-top: 25px;
    font-size: 15px;
    display: block;
  }
}
.agreement {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  font-size: 14px;
  color: #666;
  flex-wrap: wrap;
  line-height: 20px;
  a {
    color: #1989fa;
  }
}
.btn {
  margin-top: 20px;
}
.img-icon {
  width: 15px;
}
</style>
